import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=4624e4ea&scoped=true&"
import script from "./companyProfile.vue?vue&type=script&lang=js&"
export * from "./companyProfile.vue?vue&type=script&lang=js&"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=4624e4ea&prod&scoped=true&lang=css&"
import style1 from "./companyProfile.vue?vue&type=style&index=1&id=4624e4ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624e4ea",
  null
  
)

export default component.exports